import FileSaver from 'file-saver';

export const downloadAttachment = (response) => {
  const {headers, data} = response;
  const contentDisposition = headers['content-disposition'];
  if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(contentDisposition);
    let filename = '';
    if (matches != null && matches[1]) {
      filename = matches[1].replace(/['"?]/g, '');
    }
    FileSaver.saveAs(data, filename);
  }
};
